import { jsx as _jsx } from "react/jsx-runtime";
import { EAEAEA_PIXEL } from "@faire/retailer-visitor-shared/consts/EAEAEA_PIXEL";
import { isExtraXLarge } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/media";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewportWidth } from "@faire/web--source/ui/hooks/useViewportWidth";
import React from "react";
import styled from "styled-components";
export var CareersHeroImage = function() {
    var viewportWidth = useViewportWidth(function(width) {
        return width;
    });
    var regularImage = useResponsiveValue({
        mobileAndAbove: {
            src: "https://cdn.faire.com/fastly/daf277c52fc11380b2647cf74eb39a3d902d7204eb7a45eaa2b4efe24ba41404.png",
            height: 359
        },
        tabletAndAbove: {
            src: "https://cdn.faire.com/fastly/9c8e137ef6ab47622e26437ba0510c98951e32047975572fc4f78533aa8095af.png",
            height: 366
        },
        desktopAndAbove: {
            src: "https://cdn.faire.com/fastly/a7b47a8a0a80b7fbbbd6b3899aa94b02e3b169b2d96ea4a98b944cf6634fa69c.png",
            height: 506
        },
        xLargeAndAbove: {
            src: "https://cdn.faire.com/fastly/804a359e255eb59c19699730cbd199c87898f0e1aeab83f754e5ebdf25bb2903.png",
            height: 569
        }
    });
    var image = isExtraXLarge(viewportWidth) ? {
        src: "https://cdn.faire.com/fastly/f6984a411112d8dcc0f72c7acff32b3a0471886ebbc972d0a2b84ca6557170a6.png",
        height: 656
    } : regularImage;
    var isSSR = useIsSSR();
    var _optimizeImageUrl;
    return /*#__PURE__*/ _jsx(Image, {
        src: (_optimizeImageUrl = optimizeImageUrl({
            url: image.src
        }, isSSR, {
            height: image.height
        })) !== null && _optimizeImageUrl !== void 0 ? _optimizeImageUrl : EAEAEA_PIXEL,
        height: image.height
    });
};
export var CareersFooterImage = function() {
    var viewportWidth = useViewportWidth(function(width) {
        return width;
    });
    var regularImage = useResponsiveValue({
        mobileAndAbove: {
            src: "https://cdn.faire.com/fastly/30c7d8e4362efe6959dcbfe7b651f95f0726ca1c046878dc4d96360535c2d21d.png",
            height: 281
        },
        tabletAndAbove: {
            src: "https://cdn.faire.com/fastly/79dd375e54fe3beb9c6e8be8cb3fc28384883cd5acbdfc99530e5375d4c19566.png",
            height: 349
        },
        desktopAndAbove: {
            src: "https://cdn.faire.com/fastly/adfc246b99ad155184a16038c076f8ed2fea93c9c1289749f8edfe5a8d719bcf.png",
            height: 506
        },
        xLargeAndAbove: {
            src: "https://cdn.faire.com/fastly/764a4480c41da762e732e20e29f019f972d690ee71d0aa0a5ec526c73b693251.png",
            height: 569
        }
    });
    var image = isExtraXLarge(viewportWidth) ? {
        src: "https://cdn.faire.com/fastly/676f5d48e55c8c9c67f2f7a6be71dbb20acf2cef3b47011fcccc0a186a03f4f0.png",
        height: 656
    } : regularImage;
    var isSSR = useIsSSR();
    var _optimizeImageUrl;
    return /*#__PURE__*/ _jsx(Image, {
        src: (_optimizeImageUrl = optimizeImageUrl({
            url: image.src
        }, isSSR, {
            height: image.height
        })) !== null && _optimizeImageUrl !== void 0 ? _optimizeImageUrl : EAEAEA_PIXEL,
        height: image.height
    });
};
export var BelongingAtFaireFooterImage = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var image = useResponsiveValue({
        mobileAndAbove: {
            src: "https://cdn.faire.com/fastly/a12dacfc80c7408bc27dbf3abe53382eefdb10bc40454160f938e63689ef15d9.png",
            height: 375,
            alt_text: strictLocalize({
                id: "ovSfAx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Faire employees hanging out at the office"
                    }
                ]
            })
        },
        tabletAndAbove: {
            src: "https://cdn.faire.com/fastly/adddb5bad2ba189423d3f4b3ae879093d6ab4f0b877c903ee6e0b81adc1c0f2c.png",
            height: 422,
            alt_text: strictLocalize({
                id: "ovSfAx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Faire employees hanging out at the office"
                    }
                ]
            })
        },
        desktopAndAbove: {
            src: "https://cdn.faire.com/fastly/f879ae1d1f92fe94c17fdc3f24e7d31521e5c249dc6ec6e2f3b1f253b48281cc.png",
            height: 600,
            alt_text: strictLocalize({
                id: "ovSfAx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Faire employees hanging out at the office"
                    }
                ]
            })
        },
        xLargeAndAbove: {
            src: "https://cdn.faire.com/fastly/acfeec7a8eca2166fc40e275c437c3b88ccb1e1cb94e82ae696a8bfe7ca09fd6.png",
            height: 600,
            alt_text: strictLocalize({
                id: "ovSfAx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Faire employees hanging out at the office"
                    }
                ]
            })
        }
    });
    var isSSR = useIsSSR();
    var _optimizeImageUrl;
    return /*#__PURE__*/ _jsx(Image, {
        src: (_optimizeImageUrl = optimizeImageUrl({
            url: image.src
        }, isSSR, {
            height: image.height
        })) !== null && _optimizeImageUrl !== void 0 ? _optimizeImageUrl : EAEAEA_PIXEL,
        height: image.height,
        alt: image.alt_text
    });
};
var Image = styled.img.withConfig({
    componentId: "sc-423e4f93-0"
})([
    "display:block;object-fit:cover;width:100%;"
]);
